import { RootState } from '../redux';

export const selectValidateImportState = (state: RootState) => state.validateImport;
